import { Controller } from '@hotwired/stimulus'

// Warns the user before navigating away from the lab results form with unsaved changes.
// Intercepts Turbo tab navigation and browser unload events.
export default class extends Controller {
  connect() {
    this.dirty = false

    this._markDirty = () => { this.dirty = true }
    this._beforeVisit = (event) => {
      if (this.dirty && !confirm('You have unsaved changes. Leave without saving?')) {
        event.preventDefault()
      }
    }
    this._beforeUnload = (event) => {
      if (!this.dirty) return
      event.preventDefault()
      event.returnValue = ''
    }
    this._submitStart = () => { this.dirty = false }

    this.element.addEventListener('input', this._markDirty)
    this.element.addEventListener('change', this._markDirty)
    document.addEventListener('turbo:before-visit', this._beforeVisit)
    document.addEventListener('turbo:submit-start', this._submitStart)
    window.addEventListener('beforeunload', this._beforeUnload)
  }

  disconnect() {
    this.element.removeEventListener('input', this._markDirty)
    this.element.removeEventListener('change', this._markDirty)
    document.removeEventListener('turbo:before-visit', this._beforeVisit)
    document.removeEventListener('turbo:submit-start', this._submitStart)
    window.removeEventListener('beforeunload', this._beforeUnload)
  }
}
